// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';

import './styles/index.css';  // ← Updated path
import App from './App';

import { GlobalProvider } from './context';
import { store, persistor } from './store';
import { queryClient, localStoragePersister, persistOptions } from './config/queryClient';
import { config } from './config/env';
import apiService from './services/api';

// console.log("config.googleClientId===",config.googleClientId)

// Connect API service to Redux store
apiService.setStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalProvider>
        <GoogleOAuthProvider clientId={config.googleClientId}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              {localStoragePersister ? (
                <PersistQueryClientProvider
                  client={queryClient}
                  persistOptions={persistOptions}
                >
                  <App />
                </PersistQueryClientProvider>
              ) : (
                <QueryClientProvider client={queryClient}>
                  <App />
                </QueryClientProvider>
              )}
            </PersistGate>
          </Provider>
        </GoogleOAuthProvider>
      </GlobalProvider>
    </BrowserRouter>
  </React.StrictMode>
);